<template>
    <div class="federationMember">
        <div>
            <div class="country bodyL">{{ member.country }}</div>
            <div class="name">{{ member.company_name }}</div>
        </div>
        <div class="logo">
            <Image :image="member.company_logo" :width="160" imageClass="contain" />
        </div>
        <div class="plus">
            <IconPlus />
        </div>
        <NuxtLink :to="{ name: 'about-federations-slug', params: { slug: member.url } }" class="overlink"></NuxtLink>
    </div>
</template>

<script lang="ts" setup>
defineProps<{ member: any }>()
</script>

<style lang="scss" scoped>
.federationMember {
    position: relative;

    padding-left: var(--size-gutter-default);
    border-left: var(--size-thickness) solid var(--color-primary);

    .country {
        font-weight: bold;
        color: var(--color-primary);
        margin-bottom: 4px;
    }

    .name {
        max-width: 250px;
        text-wrap: balance;
    }

    .logo {
        margin-top: var(--size-gutter-default);
        position: relative;
        height: 80px;
        width: 100%;
        max-width: 160px;

        &:deep(.responsivePicture) {
            background-image: none !important;

            img {
                object-position: top left;
            }
        }
    }

    .plus {
        display: none;
    }
}


@media screen and (max-width: 600px) {
    .federationMember {

        display: flex;
        padding-inline: 0;
        border-left: 0;
        border-bottom: var(--size-thickness) solid var(--color-primary);
        padding-block: var(--size-gutter-default);
        gap: var(--size-gutter-default);
        justify-content: space-between;

        .logo {
            margin-left: auto;
            display: flex;
            align-items: flex-start;
            gap: var(--size-gutter-default);

            .plus {
                display: block;
                position: relative;
                width: 24px;
                aspect-ratio: 1;
                overflow: hidden;
            }

            &:deep(.responsivePicture) {
                background-image: none !important;

                img {
                    object-position: top right;
                }
            }
        }
    }


}
</style>